module.exports = __webpack_public_path__ + "static/ga_integration_8-d35ee9675af7fdc57504987277581d73.png";